<template>
  <div class="group-starter-picker">
    <div class="grid grid-cols-1 no-margin">
      <f7-card raised
        v-for="mode in modes"
        :key="mode.id"
        class="starter-card margin-half avocash-card"
        :class="modelValue === mode.id ? 'selected' : 'unselected'"
        @click="
          $emit('update:modelValue', modelValue === mode.id ? null : mode.id)
        "
        tabindex="0"
        @keydown.enter="$emit('update:modelValue', mode.id)"
        @keydown.space.prevent="$emit('update:modelValue', mode.id)"
        role="radio"
        :aria-checked="modelValue === mode.id"
      >
        <f7-card-header>
          <div
            class="w-8 h-8 rounded-full margin-right-half"
            :class="
              modelValue === mode.id
                ? 'bg-primary'
                : 'bg-surface-container-high'
            "
          >
            <div
              class="w-3 h-3 rounded-full"
              :class="
                modelValue === mode.id ? 'bg-on-primary' : 'bg-transparent'
              "
            />
          </div>
          <div class="flex-1 min-w-0">
            <span class="font-headline-sm font-semibold text-on-surface">{{
              $t(mode.titleKey)
            }}</span>
          </div>
          <f7-badge v-if="mode.recommended" color="primary">
            {{ $t("groupStarter.recommended") }}
          </f7-badge>
        </f7-card-header>
        <f7-card-content>
          <p class="font-body-sm text-on-surface-variant leading-snug">
            {{ $t(mode.subKey) }}
          </p>

          <div
            v-if="mode.features"
            class="display-flex flex-wrap gap-8 mt-8 text-on-surface-variant font-label-sm"
          >
            <span
              v-for="(feat, i) in mode.features"
              :key="i"
              class="display-flex align-items-center gap-4"
              :class="feat.primary ? 'text-primary' : ''"
            >
              <f7-icon :material="feat.icon" :size="14" />
              {{ $t(feat.labelKey) }}
            </span>
          </div>
        </f7-card-content>
      </f7-card>
    </div>

    <p
      class="group-type-hint font-body-sm text-on-surface-variant px-1"
    >
      {{ $t("group.creationStarterHint") }}
    </p>
  </div>
</template>

<script setup>
const modes = [
  {
    id: "COMMUNITY",
    recommended: true,
    titleKey: "groupStarter.community",
    subKey: "groupStarter.communitySub",
    features: [
      { icon: "bolt", labelKey: "groupStarter.readyNow", primary: true },
      { icon: "forum", labelKey: "groupStarter.chatEnabled" },
      { icon: "event", labelKey: "groupStarter.calendar" },
    ],
  },
  {
    id: "MONEY",
    recommended: false,
    titleKey: "groupStarter.money",
    subKey: "groupStarter.moneySub",
    features: null,
  },
  {
    id: "COMMERCE",
    recommended: false,
    titleKey: "groupStarter.commerce",
    subKey: "groupStarter.commerceSub",
    features: null,
  },
];

defineProps({ modelValue: { type: String, default: null } });
defineEmits(["update:modelValue"]);
</script>

<style scoped>
.group-starter-picker {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.starter-card {
  border-radius: 16px;
  background: var(--f7-card-bg-color, #fff);
  border: 1px solid var(--f7-list-item-border-color, rgba(0, 0, 0, 0.08));
  transition: background-color 0.2s ease, border-color 0.2s ease,
    box-shadow 0.2s ease, transform 0.1s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  cursor: pointer;
  min-height: 140px;
}

.starter-card:focus-visible {
  outline: 2px solid var(--avocash-primary, #0009ff);
  outline-offset: 2px;
}

.starter-card.unselected:hover {
  background: var(--f7-surface-container, #f8f9fa);
  border-color: var(--avocash-outline, rgba(0, 0, 0, 0.12));
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.starter-card.selected {
  background: var(--avocash-green-light, #e8f0fe);
  border-color: var(--avocash-primary, #0009ff);
  box-shadow: 0 2px 8px rgba(0, 9, 255, 0.18);
}

.starter-card.unselected:active {
  transform: scale(0.98);
}





.group-type-hint {
  margin-top: 12px;
}
</style>
